<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :addButtonIcon="addButtonIcon"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :useModelInsteadOfButton="useModelInsteadOfButton"    
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
        :isLoss="isLoss"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue"; 
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,      
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    entry: Object,
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    isLoss: {
      type: Boolean,
      default: false,
    },
    cropLotId: {
      type: String,
      default: null,
    },
    modelNameSingular: String,
    addButtonIcon:{
      type: String,
      default: "mdi-minus",
    }
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      if(this.cropLotId){
        this.$apollo
          .query({
            query: LOAD_NEW_EXIT_STORAGE_ADJUSTMENT_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              cropLotId: this.cropLotId,
            }
          })
          .then(response => {
            // this.entry = response.data.accountContext.exitStorageAdjustment;
            // console.log("entry", this.entry);
            // this.entry.isLoss = this.isLoss;
            this.extraData = response.data;
            var res = this.extraData.accountContext.allStockAdjustmentReasons.find((item) => item.name == 'Ajuste de Colheita');
            // console.log('res', res);
            this.entry.stockAdjustmentReason = res;
            this.entry.stockAdjustmentReasonId = res.id;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }else{
        this.$apollo
          .query({
            query: LOAD_NEW_EXIT_STORAGE_ADJUSTMENT_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              movementItemId: this.entry.movementItemId,
            }
          })
          .then(response => {
            // this.entry = response.data.accountContext.exitStorageAdjustment;
            // this.entry.isLoss = this.isLoss;
            // console.log("entry", this.entry);
            this.extraData = response.data;
            this.entry.validations = response.data.accountContext.exitStorageAdjustment.validations;
            // for(var item in this.entry.exitMovementItemsAttributes){
            //   delete item.isNewItemInStorage;
            //   // item.isStockEntryType = false;
            // }
            this.entry.exitMovementItemsAttributes.forEach(item => {
              delete item.isNewItemInStorage;
              // item.isStockEntryType = false;
            });

            this.entry.dummyExitMovementItemsAttributes = [];
            this.entry.removeFromStorage = true;
            
            this.entry.isStockEntryType = false;
            // console.log("alter", this.entry);
            var res = this.extraData.accountContext.allStockAdjustmentReasons.find((item) => item.name == 'Ajuste de Colheita');
            // console.log('res', res);
            this.entry.stockAdjustmentReason = res;
            this.entry.stockAdjustmentReasonId = res.id;
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
      }
    },
    createServerEntry: function(field) {
      // console.log("STOCK_ADJUSTMENT", field, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(field, this.entry.validations));
      this.pageLoading = true;
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(field, this.entry.validations);

      // for(var item in filtered.exitMovementItemsAttributes){
      //   delete item.isNewItemInStorage;
      //   // item.isStockEntryType = false;
      // }
      
      this.$apollo
        .mutate({
          mutation: CREATE_EXIT_STORAGE_ADJUSTMENT,
          variables: {
            input: filtered,
          }
        })
        .then(response => {
          var errors = response.data.createExitStorageAdjustment.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.entry.id = response.data.createExitStorageAdjustment.stockAdjustment.id;
            this.$refs.baseNew.closeDialog();
            this.entry.adjustmentTypeText = "Saída";
            this.entry.storage = this.extraData.accountContext.allStorages.filter(storage=> storage.id == this.entry.storageId)[0];
            this.entry.entryMovementItemsAttributes = [];
            
            // console.log("crated", this.entry);
            this.$emit("entry-created", this.entry);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_EXIT_STORAGE_ADJUSTMENT_QUERY = gql `
  query($cropLotId: ID, $movementItemId: ID){
    accountContext{
      exitStorageAdjustment(cropLotId: $cropLotId) {
        id
        code
        date
        description
        removeFromStorage
        isStockEntryType
        storageId
        storage{
          id
          name
        }
        exitMovementItemsAttributes {
          id
          quantity
          packagingId
          packaging{
            id
            name
          }
          itemId
          item{
            id
            name
          }
          exitMovementItemLotsAttributes{
            manufacturingLotId
            name
            quantity
          }
        }
        dummyExitMovementItemsAttributes {
          id
        }
        stockAdjustmentReasonId
        validations
      }
      allStorages {
        id
        name
        location
      }
      allGreenhouses{
        id
        name
        location
      }
      allStockAdjustmentReasons {
        id
        name
      }

      allCropsForAdjustment(movementItemId: $movementItemId)
    }
  }
`;

const CREATE_EXIT_STORAGE_ADJUSTMENT = gql `
  mutation($input: ExitStorageAdjustmentCreateInputObject!) {
    createExitStorageAdjustment(input: $input) {
      stockAdjustment {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
